import { ExternalLink, Instagram, Facebook } from "lucide-react";

export const PLATFORMS = [
  { key: "spotify", label: "Spotify", group: "listen" },
  { key: "apple_music", label: "Apple Music", group: "listen" },
  { key: "deezer", label: "Deezer", group: "listen" },
  { key: "tidal", label: "Tidal", group: "listen" },
  { key: "soundcloud", label: "SoundCloud", group: "listen" },
  { key: "youtube", label: "YouTube", group: "listen" },
  { key: "beatport", label: "Beatport", group: "buy" },
  { key: "bandcamp", label: "Bandcamp", group: "buy" },
  { key: "traxsource", label: "Traxsource", group: "buy" },
  { key: "itunes", label: "iTunes Store", group: "buy" },
  { key: "amazon_music", label: "Amazon Music", group: "buy" },
  { key: "juno", label: "Juno Download", group: "buy" },
  { key: "instagram", label: "Instagram", Icon: Instagram, group: "social" },
  { key: "facebook", label: "Facebook", Icon: Facebook, group: "social" },
];

export const PlatformLinks = ({ links = {}, prefix = "platform", size = "md", group, variant }) => {
  const items = PLATFORMS.filter((p) => links[p.key] && (!group || p.group === group));
  if (!items.length) return null;
  const pad = size === "sm" ? "px-2.5 py-1 text-[10px]" : "px-4 py-2 text-xs";
  const tone = variant === "buy"
    ? "border-hot/50 text-white bg-hot/10 hover:bg-hot hover:text-[#151827]"
    : "border-white/20 text-zinc-200 hover:border-emerald-400 hover:text-emerald-300 hover:bg-emerald-400/10";
  return (
    <div className="flex flex-wrap gap-2">
      {items.map(({ key, label, Icon = ExternalLink }) => (
        <a key={key} href={links[key]} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-${key}-link`}
          onClick={(e) => e.stopPropagation()}
          className={`${pad} inline-flex items-center gap-1.5 rounded-full border font-mono-tga uppercase tracking-[0.15em] hover:-translate-y-0.5 transition-[color,background-color,border-color,transform] duration-200 ${tone}`}>
          <Icon className="h-3 w-3" />{label}
        </a>
      ))}
    </div>
  );
};
